import React from 'react';
import AppHeader from '../../../../components/Header';

/*
 This component is used for the Quest header if "showHeader" is set to true
*/
export default () => <AppHeader noLogoLink />;
